import React, { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Header = () => {
  const { t, i18n } = useTranslation();
  const [naviStatus, setNaviStatus] = useState(false);
  const navigate = useNavigate();

  // 로컬 스토리지에서 언어 정보 불러오기
  useEffect(() => {
    const storedLanguage = localStorage.getItem("language");
    if (storedLanguage) {
      i18n.changeLanguage(storedLanguage);
    }
  }, [i18n]);

  const showNavi = () => {
    var navi = document.querySelector(".navi_short_menu_box");
    if (naviStatus === false) {
      setNaviStatus(true);
      navi.classList.add("active");
    } else {
      setNaviStatus(false);
      navi.classList.remove("active");
    }
  };

  // 언어 변경 함수
  const changeLanguage = (lng) => {
    // 언어 변경
    i18n.changeLanguage(lng);
    // 로컬 스토리지에 언어 정보 저장
    localStorage.setItem("language", lng);
  };

  const movePage = (path) => {
    // scrollToTop();
    navigate(path);
    window.location.reload();
  };

  return (
    <div className="navi_area">
      <div className="navi_default">
        <div className="navi_box left">
          <div onClick={() => movePage("/")}>
            <div className="navi_logo"></div>
          </div>
        </div>
        <div className="navi_box right">
          <div className="navi_menu_box sub">
            <div className="navi_menu">
              <div onClick={() => movePage("/about")}>{t("menu.company")}</div>
            </div>
            <div className="sub_menu_box">
              <ul className="sub_menu_ul">
                <li className="sub_menu">
                  <div onClick={() => movePage("/about")}>
                    {t("menu.about")}
                  </div>
                </li>
                <li className="sub_menu">
                  <div onClick={() => movePage("/ceo")}>{t("menu.ceo")}</div>
                </li>
                <li className="sub_menu">
                  <div onClick={() => movePage("/vision")}>
                    {t("menu.vision")}
                  </div>
                </li>
                <li className="sub_menu">
                  <div onClick={() => movePage("/coretech")}>
                    {t("menu.coretech")}
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div className="navi_menu_box sub">
            <div className="navi_menu">
              <div onClick={() => movePage("/project")}>
                {t("menu.research")}
              </div>
            </div>
            <div className="sub_menu_box">
              <ul className="sub_menu_ul">
                <li className="sub_menu">
                  <div onClick={() => movePage("/project")}>
                    {t("menu.project")}
                  </div>
                </li>
                <li className="sub_menu">
                  <div onClick={() => movePage("/publications")}>
                    {t("menu.publications")}
                  </div>
                </li>
                <li className="sub_menu">
                  <div onClick={() => movePage("/patents")}>
                    {t("menu.patents")}
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div className="navi_menu_box sub">
            <div className="navi_menu">
              <div onClick={() => movePage("/news")}>{t("menu.news")}</div>
            </div>
            <div className="sub_menu_box">
              <ul className="sub_menu_ul">
                <li className="sub_menu">
                  <div onClick={() => movePage("/news")}>{t("menu.news")}</div>
                </li>
              </ul>
            </div>
          </div>

          <div className="navi_menu_box sub">
            <div className="navi_menu">
              <div onClick={() => movePage("/contact")}>
                {t("menu.contact")}
              </div>
            </div>
            <div className="sub_menu_box">
              <ul className="sub_menu_ul">
                <li className="sub_menu">
                  <div onClick={() => movePage("/contact")}>
                    {t("menu.contactUs")}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="lang_box">
        {i18n.language === "en" && (
          <div className="lang_btn" onClick={() => changeLanguage("ko")}>
            {t("header.ko")}
          </div>
        )}
        {i18n.language === "ko" && (
          <div className="lang_btn" onClick={() => changeLanguage("en")}>
            {t("header.en")}
          </div>
        )}
      </div>

      <div className="navi_shortcut">
        <div className="navi_box left">
          <div onClick={() => movePage("/")}>
            <div className="navi_logo"></div>
          </div>
        </div>
        <div className="navi_short_box">
          <div className="navi_short_icon_box">
            <div className="navi_short_icon" onClick={() => showNavi()}></div>
          </div>
          <div className="lang_box_shortcut">
            {i18n.language === "en" && (
              <div className="lang_btn" onClick={() => changeLanguage("ko")}>
                {t("header.ko")}
              </div>
            )}
            {i18n.language === "ko" && (
              <div className="lang_btn" onClick={() => changeLanguage("en")}>
                {t("header.en")}
              </div>
            )}
          </div>
          <div className="navi_short_menu_box">
            <div className="navi_short_menu" onClick={() => movePage("/about")}>
              Company
            </div>
            <div
              className="navi_short_menu"
              onClick={() => movePage("/project")}
            >
              Research
            </div>
            <div className="navi_short_menu" onClick={() => movePage("/news")}>
              News
            </div>
            <div
              className="navi_short_menu"
              onClick={() => movePage("/contact")}
            >
              Contact
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
